import { ServiceType } from '../enum/EnumRepository';
import { getConfig } from '../env/envManager';

const config = getConfig();

const getMimeTypeFromBase64 = (base64: string): string => {
  // Base64의 헤더 부분에서 MIME 타입 추출
  const mimeMatch = base64.match(/^data:(.+);base64,/);
  if (mimeMatch) {
    return mimeMatch[1]; // MIME 타입 반환 (예: "image/jpeg")
  }
  throw new Error("Invalid Base64 string"); // 잘못된 Base64 데이터 처리
}

export const makePrefix = (serviceType: ServiceType, identifier: string[]): string => {
  switch (serviceType) {
    case ServiceType.WORK:
      return `work/${identifier[0]}/${Date.now()}`;
    case ServiceType.PROJECT:
      return `project/${identifier[0]}/${Date.now()}`;
    case ServiceType.DETAIL:
      return `work/${identifier[0]}/detail/${identifier[1]}/${Date.now()}`;
    case ServiceType.DOCUMENT:
      return `project/${identifier[0]}/document/${identifier[1]}/${Date.now()}`;
    case ServiceType.PDF:
      return `project/${identifier[0]}/pdf/${identifier[1]}/${Date.now()}`;
    case ServiceType.MEMBER_INFO:
      return `memberInfo/${Date.now()}`;
    case ServiceType.SEO:
      return `seo/${Date.now()}`;
    case ServiceType.TEXT_BLOCK:
      return `text/${identifier[0]}/text-block/${identifier[1]}/${Date.now()}`;
    case ServiceType.FORMATION:
      return `project/${identifier[0]}/formation/${identifier[1]}/item/${identifier[2]}/${Date.now()}`;
    case ServiceType.BILLBOARD:
    default:
      return `billboard/${Date.now()}`;
  }
}
export const makeOriginFilename = (mimeType: string): string => {
  const fileExtension = mimeType.split("/")[1];
  return `origin.${fileExtension}`;
}

export const base64ToFileWithMime = (base64: string): File => {
  const mimeType = getMimeTypeFromBase64(base64); // MIME 타입 추출
  const base64Data = base64.split(',')[1]; // Base64 헤더 제거
  const binaryData = atob(base64Data); // Base64를 디코딩하여 바이너리 데이터로 변환

  // 바이너리 데이터를 Uint8Array로 변환
  const arrayBuffer = new Uint8Array(binaryData.length);
  for (let i = 0; i < binaryData.length; i++) {
    arrayBuffer[i] = binaryData.charCodeAt(i);
  }
  // Blob 생성
  const blob = new Blob([arrayBuffer], { type: mimeType });
  // File 객체 생성
  return new File([blob], makeOriginFilename(mimeType), { type: mimeType });
}

export const convertS3UrlToCloudFrontUrl = (s3Url: string): string => {
  if (s3Url === "") return s3Url;
  // URL 형식이 아닌 경우 바로 리턴
  if (!s3Url.startsWith('http')) {
    return s3Url;
  }
  
  const s3Domain = config.s3BucketDomain;
  const cloudFrontDomain = config.cloudFrontDomain;

  try {
    const url = new URL(s3Url);
    if (url.hostname === s3Domain) {
      url.hostname = cloudFrontDomain;
    }
    return url.toString();
  } catch (error) {
    console.error("Invalid URL:", error);
    return s3Url;
  }
}
